<script lang="ts">
	//UI
	import { GoBackButton } from "@hitit/new_ui/src";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import ReaderControl from "@hitit/mbr/src/v7/component/Notice/ReaderControl.svelte";
	import NoticeReader from "@hitit/hub/src/v7/components/notice/NoticeReader.svelte";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";
	import AdditionalInfo from "../component/Notice/AdditionalInfo.svelte";
	import ViewInfos from "../component/Notice/ViewInfos.svelte";
	//Utils
	import { popup } from "@hitit/hub/src/v7/store";
	import { api, notifications } from "@hitit/hub/src/stores";
	import { navigate } from "svelte-routing";
	import { processingDate } from "@hitit/hub/src/v7/utils";
	import { onDestroy } from "svelte";
	//Types
	import type { NewsVisitDTO } from "@hitit/api";
	//Props
	export let noticeId: string;
	//Constants
	//Variables
	let loading = false;
	let date = "";
	let article = "";
	let title = ``;
	let status = "";
	let newsVisitDTOs: NewsVisitDTO[] = [];
	let publishedDate = "";
	let obsoletedDate = "";
	//Functions
	const backClickHandler = () => history.back();
	const editHandler = () => navigate(`/hubsetting/notice/edit/${noticeId}`);
	const deleteHadnler = () => {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: "global.notice.you_want_to_delete",
				accept: () => deleteNotice(),
				cancel: () => ($popup = undefined),
			},
		};
	};

	async function getNotice(noticeId: string) {
		try {
			loading = true;
			const { data } = await $api.getNewsDocument(noticeId);
			const { content, documentState, createdDate } = data.newsDTO;

			title = data.newsDTO.title;
			article = content;
			date = processingDate(createdDate as string);
			status = documentState;
			newsVisitDTOs = data.newsDTO.newsViewDTOs || [];
			publishedDate = processingDate(data.newsDTO.publishedDate);
			obsoletedDate = processingDate(data.newsDTO.obsoletedDate);
		} catch (error) {
			alert("불러오기 실패");
			console.log(error);
		} finally {
			loading = false;
		}
	}

	async function deleteNotice() {
		try {
			$popup = undefined;
			loading = true;
			await $api.deleteNewsDocument(noticeId);
			notifications.append("SUCCESS", `공지사항 (${title})이 삭제되었습니다.`);
			navigate(`/hubsetting/notice`);
		} catch (error) {
			notifications.append(
				"ERROR",
				`삭제 중 오류가 발생하였습니다.<br/>${(error as Error).message}`
			);
		} finally {
			loading = false;
		}
	}
	//Do
	$: getNotice(noticeId);

	onDestroy(() => {
		$popup = undefined;
	});
</script>

{#if loading}
	<ContainerLoading />
{/if}
<div class="container">
	<div class="back">
		<GoBackButton on:click={backClickHandler} />
	</div>
	<div class="body">
		<NoticeReader title={title} date={date} article={article}>
			<div slot="control">
				<ReaderControl
					status={status}
					on:EDIT={editHandler}
					on:DELETE={deleteHadnler}
				/>
			</div>
			<div slot="additonal">
				<AdditionalInfo
					viewCount={newsVisitDTOs.length}
					publishedDate={publishedDate}
					obsoletedDate={obsoletedDate}
					createdDate={date}
				/>
			</div>
		</NoticeReader>
		<ViewInfos visitDTOs={newsVisitDTOs} />
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		padding-top: 50px;
		position: relative;
		background-color: #f0f0f4;
		box-sizing: border-box;
		margin-top: -90px;
		.back {
			width: 30px;
			height: 27px;
			position: absolute;
			top: 0px;
			right: 0px;
		}

		.body {
			display: flex;
			flex-direction: column;
			gap: 20px;
			:global(#Notice-reader) {
				min-height: calc(100vh - 160px);
			}
		}
	}

	@include DesktopSize {
		.container {
			margin-top: 0px;
			gap: 30px;

			.back {
				top: 0px;
			}
			.body {
				gap: 30px;
				:global(#Notice-reader) {
					min-height: calc(100vh - 260px);
				}
			}
		}
	}
</style>
